import { createSlice } from "@reduxjs/toolkit";
import { api } from "service/api";
import { Toast } from "service/toast";
import { DashboardApi } from "service/apiVariables";
import { setLoader } from "./loader";
import { addQuery } from "helpers/utis";
const today = new Date();

const past7Days = new Date();
past7Days.setDate(today.getDate() - 7);

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    projectCount: {},
    filterList: {},
    selectedProject: null,
    productivityStartDate: past7Days.toLocaleDateString("en-CA", {
      timeZone: "Asia/Kolkata",
    }),
    productivityEndDate: today.toLocaleDateString("en-CA", {
      timeZone: "Asia/Kolkata",
    }),
    wingGraphData: {},
    tradeData: "",
    selectedTrade: null,
    foremanGraphData: {},
    tradeGraphData: {},
    attendanceData: [],
    attendanceSelectedProject: "",
    attendanceStartDate: past7Days.toLocaleDateString("en-CA", {
      timeZone: "Asia/Kolkata",
    }),
    attendanceEndDate: today.toLocaleDateString("en-CA", {
      timeZone: "Asia/Kolkata",
    }),
    attendanceProjectsList: [],
    wingGraphLoading: false,
    foremanGraphLoading: false,
    tradeGraphLoading: false,
    attendanceGraphLoading: false,
    attendanceProjectsLoading: false,

    // attendance overview pie - separate state, no default values
    attendanceOverviewSelectedProject: "",
    attendanceOverviewFromDate: past7Days.toLocaleDateString("en-CA", {
      timeZone: "Asia/Kolkata",
    }),
    attendanceOverviewToDate: today.toLocaleDateString("en-CA", {
      timeZone: "Asia/Kolkata",
    }),
    attendanceOverviewPieData: [],
    attendanceOverviewPieLoading: false,
  },
  reducers: {
    saveProjectsCount: (state, action) => {
      state.projectCount = action.payload;
    },
    saveFilterList: (state, action) => {
      state.filterList = action.payload;
    },
    saveWingsGraphData: (state, action) => {
      state.wingGraphData = action.payload[0];
    },
    saveAttendanceGraphData: (state, action) => {
      state.attendanceData = action.payload;
    },
    saveForemanGraphData: (state, action) => {
      state.foremanGraphData = action.payload[0];
    },
    saveTradeGraphData: (state, action) => {
      state.tradeGraphData = action.payload;
    },
    saveTradeData: (state, action) => {
      state.tradeData = action.payload;
    },
    saveAttendanceProjectsList: (state, action) => {
      state.attendanceProjectsList = action.payload;
    },

    // attendance overview pie
    saveAttendanceOverviewPieData: (state, action) => {
      state.attendanceOverviewPieData = action.payload;
    },
    clearAttendanceOverviewPieData: (state) => {
      state.attendanceOverviewPieData = [];
    },

    setSelectedTrade: (state, action) => {
      state.selectedTrade = action.payload;
    },
    setSelectedProject: (state, action) => {
      state.selectedProject = action.payload;
    },
    // Productivity date actions
    setProductivityStartDate: (state, action) => {
      state.productivityStartDate = action.payload;
    },
    setProductivityEndDate: (state, action) => {
      state.productivityEndDate = action.payload;
    },
    // Attendance date actions
    setAttendanceSelectedProject: (state, action) => {
      state.attendanceSelectedProject = action.payload;
    },
    setAttendanceStartDate: (state, action) => {
      state.attendanceStartDate = action.payload;
    },
    setAttendanceEndDate: (state, action) => {
      state.attendanceEndDate = action.payload;
    },

    // Attendance overview filter actions
    setAttendanceOverviewSelectedProject: (state, action) => {
      state.attendanceOverviewSelectedProject = action.payload;
    },
    setAttendanceOverviewFromDate: (state, action) => {
      state.attendanceOverviewFromDate = action.payload;
    },
    setAttendanceOverviewToDate: (state, action) => {
      state.attendanceOverviewToDate = action.payload;
    },

    // Graph loading states
    setWingGraphLoading: (state, action) => {
      state.wingGraphLoading = action.payload;
    },
    setForemanGraphLoading: (state, action) => {
      state.foremanGraphLoading = action.payload;
    },
    setTradeGraphLoading: (state, action) => {
      state.tradeGraphLoading = action.payload;
    },
    setAttendanceGraphLoading: (state, action) => {
      state.attendanceGraphLoading = action.payload;
    },
    setAttendanceProjectsLoading: (state, action) => {
      state.attendanceProjectsLoading = action.payload;
    },
    setAttendanceOverviewPieLoading: (state, action) => {
      state.attendanceOverviewPieLoading = action.payload;
    },
  },
});

export const getTotalProjectsAct = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    api({ ...DashboardApi.getTotalProjects })
      .then((data) => {
        dispatch(saveProjectsCount(data?.data));
        resolve(data);
      })
      .catch(({ message }) => reject(Toast({ type: "error", message })));
  });
};

export const getDashboardFilterAct = (body) => (dispatch) => {
  return new Promise((resolve, reject) => {
    api({ ...DashboardApi.getDashboardFilterList, body })
      .then(({ data }) => {
        dispatch(setLoader(false));
        dispatch(saveFilterList(data));
        resolve(data);
      })
      .catch(({ message }) => {
        dispatch(setLoader(false));
        dispatch(saveFilterList({}));
        reject(Toast({ type: "error", message }));
      });
  });
};

export const getWingsGraphData = (query) => (dispatch) => {
  dispatch(setWingGraphLoading(true));
  addQuery(query, DashboardApi.wingWiseProductivity);
  return new Promise((resolve, reject) => {
    api({ ...DashboardApi.wingWiseProductivity })
      .then(({ data }) => {
        dispatch(saveWingsGraphData(data));
        dispatch(setWingGraphLoading(false));
        resolve(data);
      })
      .catch(({ message }) => {
        dispatch(saveWingsGraphData({}));
        dispatch(setWingGraphLoading(false));
        reject(Toast({ type: "error", message }));
      });
  });
};

export const getAttendanceGraphData = (query) => (dispatch) => {
  dispatch(setAttendanceGraphLoading(true));
  addQuery(query, DashboardApi?.attendanceGrapgData);
  return new Promise((resolve, reject) => {
    api({ ...DashboardApi.attendanceGrapgData })
      .then(({ data }) => {
        dispatch(saveAttendanceGraphData(data));
        dispatch(setAttendanceGraphLoading(false));
        resolve(data);
        Toast({ type: "success", message: "Data Fetched Successfully" });
      })
      .catch(({ message }) => {
        dispatch(saveAttendanceGraphData([]));
        dispatch(setAttendanceGraphLoading(false));
        reject(Toast({ type: "error", message }));
      });
  });
};

export const getAttendanceOverviewPieData = (query) => (dispatch) => {
  dispatch(setAttendanceOverviewPieLoading(true));

  DashboardApi.getAttendanceCategoryChartApi.addQuery = query;

  const apiConfig = { ...DashboardApi.getAttendanceCategoryChartApi };
  addQuery(query || {}, apiConfig);

  return new Promise((resolve, reject) => {
    api({ ...DashboardApi.getAttendanceCategoryChartApi })
      .then(({ data }) => {
        let list = [];

        if (Array.isArray(data)) {
          list = data;
        } else if (Array.isArray(data?.data)) {
          list = data.data;
        } else if (Array.isArray(data?.data_list)) {
          list = data.data_list;
        }

        dispatch(saveAttendanceOverviewPieData(list));
        dispatch(setAttendanceOverviewPieLoading(false));
        resolve(list);
      })
      .catch(({ message }) => {
        dispatch(saveAttendanceOverviewPieData([]));
        dispatch(setAttendanceOverviewPieLoading(false));
        reject(Toast({ type: "error", message }));
      });
  });
};

export const getAttendanceProjectsList = () => (dispatch) => {
  dispatch(setAttendanceProjectsLoading(true));
  return new Promise((resolve, reject) => {
    api({ ...DashboardApi.attendanceProjectsList })
      .then(({ data }) => {
        dispatch(saveAttendanceProjectsList(data));
        dispatch(setAttendanceProjectsLoading(false));
        resolve(data);
      })
      .catch(({ message }) => {
        dispatch(saveAttendanceProjectsList([]));
        dispatch(setAttendanceProjectsLoading(false));
        reject(Toast({ type: "error", message }));
      });
  });
};

export const getForemanGraphData = (query) => (dispatch) => {
  dispatch(setForemanGraphLoading(true));
  addQuery(query, DashboardApi.foremanWiseProductivity);
  return new Promise((resolve, reject) => {
    api({ ...DashboardApi.foremanWiseProductivity })
      .then(({ data }) => {
        dispatch(saveForemanGraphData(data));
        dispatch(setForemanGraphLoading(false));
        resolve(data);
      })
      .catch(({ message }) => {
        dispatch(saveForemanGraphData({}));
        dispatch(setForemanGraphLoading(false));
        reject(Toast({ type: "error", message }));
      });
  });
};

export const getTradeGraphData = (query) => (dispatch) => {
  dispatch(setTradeGraphLoading(true));
  addQuery(query, DashboardApi.tradeWiseProductivity);
  return new Promise((resolve, reject) => {
    api({ ...DashboardApi.tradeWiseProductivity })
      .then(({ data }) => {
        dispatch(saveTradeGraphData(data));
        dispatch(setTradeGraphLoading(false));
        resolve(data);
      })
      .catch(({ message }) => {
        dispatch(saveTradeGraphData({}));
        dispatch(setTradeGraphLoading(false));
        reject(Toast({ type: "error", message }));
      });
  });
};

export const getTradeOptionList = () => (dispatch) => {
  return new Promise((reject) => {
    api({ ...DashboardApi.tradeList })
      .then((data) => dispatch(saveTradeData(data)))
      .catch(({ message }) => reject(Toast({ type: "error", message })));
  });
};

export const {
  saveProjectsCount,
  saveFilterList,
  setSelectedProject,
  setProductivityStartDate,
  setProductivityEndDate,
  saveWingsGraphData,
  setSelectedTrade,
  saveTradeData,
  saveAttendanceProjectsList,
  saveForemanGraphData,
  saveTradeGraphData,
  saveAttendanceGraphData,
  setAttendanceSelectedProject,
  setAttendanceStartDate,
  setAttendanceEndDate,
  setWingGraphLoading,
  setForemanGraphLoading,
  setTradeGraphLoading,
  setAttendanceGraphLoading,
  setAttendanceProjectsLoading,

  saveAttendanceOverviewPieData,
  clearAttendanceOverviewPieData,
  setAttendanceOverviewPieLoading,
  setAttendanceOverviewSelectedProject,
  setAttendanceOverviewFromDate,
  setAttendanceOverviewToDate,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
